const adminOverview = {
  actions: {
    retry: '重试',
  },
  activity: {
    empty: '暂无最近应用更新。',
    justNow: '刚刚',
    title: '最近动态',
  },
  description: '集中查看组织、应用、模型网关与运营工作的关键待办和运行状态。',
  error: {
    description: '总览依赖多个后台接口，请检查网络或稍后重试。',
    title: '无法加载总览',
  },
  metrics: {
    activeKeys: {
      description: '当前启用的模型分发密钥',
      label: '分发密钥',
    },
    activeMembers: {
      description: '当前可访问用户端的成员账号',
      label: '平台成员',
    },
    activeModels: {
      description: '可供应用或 {{hubAgentName}} 调用',
      label: '启用模型',
    },
    pendingReview: {
      description: '应用发布链路中的待处理项',
      label: '待审核任务',
    },
  },
  quickEntries: {
    apps: '应用列表',
    departments: '部门管理',
    modelKeys: '模型分发',
    modelProvider: '模型注册',
    review: '上下架审核',
    title: '快捷入口',
  },
  tasks: {
    branding: {
      detail: '站点标题会影响登录页、侧边栏和浏览器标题。',
      title: '完善品牌设置',
    },
    coreAgent: {
      detail: '启用后用户端首页可使用 {{hubAgentName}}。',
      title: '启用 {{hubAgentName}}',
    },
    count: '共 {{count}} 项待处理',
    empty: '暂无需要处理的关键事项。',
    expiringKeys: {
      detail: '{{count}} 个启用密钥将在 14 天内到期。',
      title: '轮换即将过期的分发密钥',
    },
    noKeys: {
      detail: '创建分发密钥后，下游服务才能调用模型网关。',
      title: '创建模型分发密钥',
    },
    noModels: {
      detail: '注册并启用模型后，应用和 {{hubAgentName}} 才能选择模型。',
      title: '注册可用模型',
    },
    pendingReview: {
      detail: '{{count}} 个应用等待进入后续发布流转。',
      title: '审核待发布应用',
    },
    quotaRules: {
      detail: '{{count}} 条启用配额规则正在生效，建议定期复核。',
      title: '复核分发密钥配额',
    },
    sso: {
      detail: '配置 SSO 后，成员可以通过企业身份源登录。',
      title: '配置成员认证',
    },
    title: '待处理事项',
  },
  title: '总览',
}

export default adminOverview
